import { identity, isUndefined } from 'underscore';
import {
  getComponentById,
  getDataSourceByKey,
} from '@bingads-webui-campaign-react/smart-component-util';
import {
  isAndroid,
  isIOS,
} from '@bingads-webui-campaign-react/smart-page-util';
import { SmartActionButtonTypes } from './smart-action-types';

export const proxyReadFromCTAComponentConfig = (componentConfig) => {
  if (!componentConfig) {
    return { actionType: SmartActionButtonTypes.GetQuote.name };
  }

  return {
    linkUrl: componentConfig.linkUrl,
    linkText: componentConfig.linkText,
    actionType: componentConfig.actionType || SmartActionButtonTypes.GetQuote.name,
  };
};

const androidPrefix = 'geo://?q=';
const iOSPrefix = 'http://maps.apple.com/?q=';

const formatUri = (prefix, uri) => (prefix + encodeURI(uri));

export const getIsUsedExternalLink = (componentConfig) => {
  const { isExternalLink } = componentConfig;

  // True and undefined are both regarded as isExternalLink
  return isExternalLink || isUndefined(isExternalLink);
};

export const getDirectionUri = (location) => {
  const { uriPrefix } = SmartActionButtonTypes.GetDirections;

  let directionUri = uriPrefix && location
    ? formatUri(uriPrefix, location)
    : '';

  if (isAndroid()) {
    directionUri = formatUri(androidPrefix, location);
  } else if (isIOS()) {
    directionUri = formatUri(iOSPrefix, location);
  }

  return directionUri;
};

export const getActionButtonProps =
  (siteConfig, id, overrideButtonConfig, useIconButton = false) => {
    const componentConfig = overrideButtonConfig || getComponentById(siteConfig, id);
    const { actionType } = proxyReadFromCTAComponentConfig(componentConfig);
    const {
      text,
      uriPrefix,
      dataSourceName,
      editorLabel,
      isTextEditable,
      isLinkEditable,
      isFormLink,
      icon,
      iconText,
      operations = [],
      readProcessor = identity,
      writeProcessor = identity,
      validator,
    } = SmartActionButtonTypes[actionType];

    const { linkUrl, linkText } = componentConfig;

    const dataSourceValue = getDataSourceByKey(siteConfig, dataSourceName);
    let targetUri = uriPrefix && dataSourceValue ?
      formatUri(uriPrefix, dataSourceValue) :
      '';

    if (actionType === SmartActionButtonTypes.GetDirections.name) {
      targetUri = getDirectionUri(dataSourceValue);
    }

    return {
      id,
      componentConfig,
      actionType,
      text: useIconButton && iconText ? iconText : text,
      dataSourceName,
      dataSourceValue,
      editorLabel,
      targetUri,
      linkUrl,
      linkText,
      isTextEditable,
      isLinkEditable,
      isFormLink,
      icon,
      defaultLinkText: SmartActionButtonTypes.CustomLink.text,
      operations,
      readProcessor,
      writeProcessor,
      validator,
    };
  };
